export { default as GlobalStyles } from "./GlobalStyles";
export { default as Icons, IconsConsumer, IconsProvider } from "./Icons";
export { default as Svg } from "./Svg";
export { IThemeProps, themes } from "./Theme";
